/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forEmail } from "./constants";
const CancelToken = axios.CancelToken;

export let cancelGetEmailsApi;
export async function getEmails(headers, query = "") {
    if (headers) {
        const emails = await axios.get(apiUrl_forEmail + "list?" + query, {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetEmailsApi = c;
            }),
        });
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelGetEmailDetailsApi;
export async function getEmailDetails(headers, emailTemplateId) {
    if (headers && emailTemplateId) {
        const emails = await axios.get(
            apiUrl_forEmail + "detail/" + emailTemplateId,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetEmailDetailsApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelGetEmailEventsApi;
export async function getEmailEvents(headers) {
    if (headers) {
        const emails = await axios.get(apiUrl_forEmail + "emailevents", {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetEmailEventsApi = c;
            }),
        });
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add email
export let cancelAddEmailTemplateApi;
export async function addEmailTemplate(headers, emailData) {
    if ((headers && emailData)) {
        const emails = await axios.post(
            apiUrl_forEmail + "add",
            {
                template_title: emailData.template_title,
                email_subject: emailData.email_subject,
                email_from: emailData.email_from,
                cc_email: emailData.cc_email,
                bcc_email: emailData.bcc_email,
                email_body: emailData.email_body,
                send_email_to: emailData.send_email_to,
                event_id: emailData.event_id,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddEmailTemplateApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// update email
export let cancelEditEmailTemplateApi;
export async function editEmailTemplate(headers, emailData) {
    if ((headers && emailData)) {
        const emails = await axios.put(
            apiUrl_forEmail + "edit/" + emailData.template_id,
            {
                template_title: emailData.template_title,
                email_subject: emailData.email_subject,
                email_from: emailData.email_from,
                cc_email: emailData.cc_email,
                bcc_email: emailData.bcc_email,
                email_body: emailData.email_body,
                send_email_to: emailData.send_email_to,
                event_id: emailData.event_id,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditEmailTemplateApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// update email status
export let cancelUpdateEmailStatusApi;
export async function updateEmailStatusApi(headers, statusData) {
    if (headers && statusData) {
        const emails = await axios.put(
            apiUrl_forEmail + "status/" + statusData.template_id,
            { status: statusData.status },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateEmailStatusApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// delete email
export let cancelDeleteEmailTemplateApi;
export async function deleteEmailTemplate(headers, emailId) {
    if (headers && emailId) {
        const emails = await axios.delete(
            apiUrl_forEmail + "delete/" + emailId,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteEmailTemplateApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}
